export { formatMoney } from '@/lib/shared-utils';

export function getSupplierName(
    supplier: {
        business_name: string | null;
        username: string;
    } | null | undefined,
) {
    if (!supplier) return '--';

    return supplier.business_name || supplier.username;
}
